module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('h1', [_vm._v(_vm._s(_vm.errorMessage))]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [(!_vm.loggedIn && _vm.validSite) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("\n      Login\n    ")]) : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.validSite) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_vm._v("\n      Dashboard\n    ")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d63aab9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Impersonate.vue
// module id = 540
// module chunks = 1